import * as types from './mutation-types';
import * as urls from './url-constants';
import * as textConst from './text-constants';
import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';

import * as newsData from './news';
import * as latestData from './latest';

const state = {
    loading: false,
    message: '',
    name: '',
    phone: '',
    messageInForm: '',
    
    homeNavTitle: textConst.textData.de.home.nav,
    homeText: textConst.textData.de.home.text,
    
    privateDataPolicyNavTitle: textConst.textData.de.policy.nav,
    privateDataPolicyText: textConst.textData.de.policy.text,
    
    imprintNavTitle: textConst.textData.de.imprint.nav,
    imprintText: textConst.textData.de.imprint.text,
    
    contactNavTitle: textConst.textData.de.contact.nav,
    contactText: textConst.textData.de.contact.text,
    
    aboutNavTitle: textConst.textData.de.about.nav,
    aboutText: textConst.textData.de.about.text,
    
    trainingNavTitle: textConst.textData.de.training.nav,
    trainingText: textConst.textData.de.training.text,
    
    aducationNavTitle: textConst.textData.de.aducation.nav,
    aducationText: textConst.textData.de.aducation.text,
    
    programNavTitle: textConst.textData.de.program.nav,
    programText: textConst.textData.de.program.text,

    imageName: textConst.textData.other.imageName.de,

    phoneLan: textConst.textData.other.phone.de,

    messageLan: textConst.textData.other.message.de,

    submitLan: textConst.textData.other.submit.de,
    clearLan: textConst.textData.other.clear.de,

    labelFirst: textConst.textData.other.labelFirst.de,
    labelSecond: textConst.textData.other.labelSecond.de,
    secondColumn: textConst.textData.other.secondColumn.de,

    warningFirst: textConst.textData.other.warningFirst.de,
    warningSecond: textConst.textData.other.warningSecond.de,
    warningThird: textConst.textData.other.warningThird.de,
    warningFourth: textConst.textData.other.warningFourth.de,
    warningFifth: textConst.textData.other.warningFifth.de,
    warningSixth: textConst.textData.other.warningSixth.de,

    kontaktInfo1: textConst.textData.other.kontaktInfo1.de,

    kontaktInfo2a: textConst.textData.other.kontaktInfo2a.de,
    kontaktInfo2b: textConst.textData.other.kontaktInfo2b.de,
    kontaktInfo2c: textConst.textData.other.kontaktInfo2c.de,

    kontaktInfo3a: textConst.textData.other.kontaktInfo3a.de,
    kontaktInfo3b: textConst.textData.other.kontaktInfo3b.de,
    kontaktInfo3c: textConst.textData.other.kontaktInfo3c.de,

    kontaktInfo4a: textConst.textData.other.kontaktInfo4a.de,
    kontaktInfo4b: textConst.textData.other.kontaktInfo4b.de,
    kontaktInfo4c: textConst.textData.other.kontaktInfo4c.de,

    mainInfoTitle: textConst.textData.other.mainInfoTitle.de,
    mainInfoSubTitle: textConst.textData.other.mainInfoSubTitle.de,
    mainInfo1: textConst.textData.other.mainInfo1.de,
    mainInfo2: textConst.textData.other.mainInfo2.de,
    mainInfo3: textConst.textData.other.mainInfo3.de,
    mainInfo4: textConst.textData.other.mainInfo4.de,
    mainInfo5: textConst.textData.other.mainInfo5.de,
    mainInfo6: textConst.textData.other.mainInfo6.de,
    mainInfo7: textConst.textData.other.mainInfo7.de,
    close: textConst.textData.other.close.de,

    menuAll: textConst.textData.other.menuAll.de,
    
    newsNavTitle: textConst.textData.de.news.nav,
    newsText: textConst.textData.de.news.text,

    newsArray: newsData.data.de,

    latestNews: latestData.data.de,

    language: 'DE',

}

const getters = {
    language: state => {
        return state.language
    },
    email: state => {
        return state.kontaktInfo4c.replace('E-Mail: ', '')
    },
}

const actions = {
    contactUs({
        commit
    }, postParams) {
        var mock = new MockAdapter(axios, { delayResponse: 2000 })
        mock.onAny(urls.URL).reply(200, {
          message: 'Data successfully saved!!!'
        });
        
        commit(types.CHANGE_LOADING_STATE, true)
        
        commit(types.SAVE_FORM_VALUES, postParams)
        
        axios
            .post(urls.URL, postParams)
            .then((response) => {

                commit(types.CHANGE_LOADING_STATE, false)

                commit(types.SET_RESPONSE_MESSAGE, response.data.message)
            })
            .catch(err => {
                commit(types.CHANGE_LOADING_STATE, false)
                commit(types.SET_RESPONSE_MESSAGE, err.message)
            })
    },
    setLang({
        commit
    }, lang) {
        
        commit(types.NEW_LANGUAGE, lang)
    },
    changeLang({
        commit
    }, lang) {
        
        commit(types.SET_LANGUAGE_VALUES, lang)
    },
    newsItemFullText({
                   commit
               }, index) {

        commit(types.SET_OPENED_NEWS_ITEM_TEXT, index)
    }
}

const mutations = {
    [types.SET_OPENED_NEWS_ITEM_TEXT](state, index) {
        state.newsArray[index].opened = !state.newsArray[index].opened
    },
    [types.NEW_LANGUAGE](state, lang) {
        state.language = lang
    },
    [types.CHANGE_LOADING_STATE](state, loading) {
        state.loading = loading
    },
    [types.SET_RESPONSE_MESSAGE](state, message) {
        state.message = message
    },
    [types.SAVE_FORM_VALUES](state, form) {
        state.messageInForm = form.message
        state.phone = form.phone
        state.name = form.name
    },
    [types.SET_LANGUAGE_VALUES](state, lang) {
        if(lang == 'DE'){

            state.homeNavTitle = textConst.textData.de.home.nav;
            state.homeText = textConst.textData.de.home.text;
            
            state.privateDataPolicyNavTitle = textConst.textData.de.policy.nav;
            state.privateDataPolicyText = textConst.textData.de.policy.text;
            
            state.imprintNavTitle = textConst.textData.de.imprint.nav;
            state.imprintText = textConst.textData.de.imprint.text;
            
            state.contactNavTitle = textConst.textData.de.contact.nav;
            state.contactText = textConst.textData.de.contact.text;
            
            state.aboutNavTitle = textConst.textData.de.about.nav;
            state.aboutText = textConst.textData.de.about.text;
            
            state.trainingNavTitle = textConst.textData.de.training.nav;
            state.trainingText = textConst.textData.de.training.text;
            
            state.aducationNavTitle = textConst.textData.de.aducation.nav;
            state.aducationText = textConst.textData.de.aducation.text;
            
            state.programNavTitle = textConst.textData.de.program.nav;
            state.programText = textConst.textData.de.program.text;

            state.imageName = textConst.textData.other.imageName.de;
            state.phoneLan = textConst.textData.other.phone.de;

            state.messageLan = textConst.textData.other.message.de;
            state.submitLan = textConst.textData.other.submit.de;
            state.clearLan = textConst.textData.other.clear.de;

            state.labelFirst = textConst.textData.other.labelFirst.de;
            state.labelSecond = textConst.textData.other.labelSecond.de;
            state.secondColumn = textConst.textData.other.secondColumn.de;

            state.warningFirst = textConst.textData.other.warningFirst.de;
            state.warningSecond = textConst.textData.other.warningSecond.de;
            state.warningThird = textConst.textData.other.warningThird.de;
            state.warningFourth = textConst.textData.other.warningFourth.de;
            state.warningFifth = textConst.textData.other.warningFifth.de;
            state.warningSixth = textConst.textData.other.warningSixth.de;

            state.kontaktInfo1 = textConst.textData.other.kontaktInfo1.de;

            state.kontaktInfo2a = textConst.textData.other.kontaktInfo2a.de;
            state.kontaktInfo2b = textConst.textData.other.kontaktInfo2b.de;
            state.kontaktInfo2c = textConst.textData.other.kontaktInfo2c.de;

            state.kontaktInfo3a = textConst.textData.other.kontaktInfo3a.de;
            state.kontaktInfo3b = textConst.textData.other.kontaktInfo3b.de;
            state.kontaktInfo3c = textConst.textData.other.kontaktInfo3c.de;

            state.kontaktInfo4a = textConst.textData.other.kontaktInfo4a.de;
            state.kontaktInfo4b = textConst.textData.other.kontaktInfo4b.de;
            state.kontaktInfo4c = textConst.textData.other.kontaktInfo4c.de;

            state.mainInfoTitle = textConst.textData.other.mainInfoTitle.de;
            state.mainInfoSubTitle = textConst.textData.other.mainInfoSubTitle.de;
            state.mainInfo1 = textConst.textData.other.mainInfo1.de;
            state.mainInfo2 = textConst.textData.other.mainInfo2.de;
            state.mainInfo3 = textConst.textData.other.mainInfo3.de;
            state.mainInfo4 = textConst.textData.other.mainInfo4.de;
            state.mainInfo5 = textConst.textData.other.mainInfo5.de;
            state.mainInfo6 = textConst.textData.other.mainInfo6.de;
            state.mainInfo7 = textConst.textData.other.mainInfo7.de;

            state.menuAll = textConst.textData.other.menuAll.de;
            
            state.newsNavTitle = textConst.textData.de.news.nav;
            state.newsText = textConst.textData.de.news.text;

            state.newsArray = newsData.data.de;
            state.latestNews = latestData.data.de;
            state.close = textConst.textData.other.close.de;
        }
        else{

            state.homeNavTitle = textConst.textData.en.home.nav;
            state.homeText = textConst.textData.en.home.text;
            
            state.privateDataPolicyNavTitle = textConst.textData.en.policy.nav;
            state.privateDataPolicyText = textConst.textData.en.policy.text;
            
            state.imprintNavTitle = textConst.textData.en.imprint.nav;
            state.imprintText = textConst.textData.en.imprint.text;
            
            state.contactNavTitle = textConst.textData.en.contact.nav;
            state.contactText = textConst.textData.en.contact.text;
            
            state.aboutNavTitle = textConst.textData.en.about.nav;
            state.aboutText = textConst.textData.en.about.text;
            
            state.trainingNavTitle = textConst.textData.en.training.nav;
            state.trainingText = textConst.textData.en.training.text;
            
            state.aducationNavTitle = textConst.textData.en.aducation.nav;
            state.aducationText = textConst.textData.en.aducation.text;
            
            state.programNavTitle = textConst.textData.en.program.nav;
            state.programText = textConst.textData.en.program.text;

            state.imageName = textConst.textData.other.imageName.en;
            state.phoneLan = textConst.textData.other.phone.en;

            state.messageLan = textConst.textData.other.message.en;

            state.submitLan = textConst.textData.other.submit.en;
            state.clearLan = textConst.textData.other.clear.en;

            state.labelFirst = textConst.textData.other.labelFirst.en;
            state.labelSecond = textConst.textData.other.labelSecond.en;
            state.secondColumn = textConst.textData.other.secondColumn.en;

            state.warningFirst = textConst.textData.other.warningFirst.en;
            state.warningSecond = textConst.textData.other.warningSecond.en;
            state.warningThird = textConst.textData.other.warningThird.en;
            state.warningFourth = textConst.textData.other.warningFourth.en;
            state.warningFifth = textConst.textData.other.warningFifth.en;
            state.warningSixth = textConst.textData.other.warningSixth.en;

            state.kontaktInfo1 = textConst.textData.other.kontaktInfo1.en;

            state.kontaktInfo2a = textConst.textData.other.kontaktInfo2a.en;
            state.kontaktInfo2b = textConst.textData.other.kontaktInfo2b.en;
            state.kontaktInfo2c = textConst.textData.other.kontaktInfo2c.en;

            state.kontaktInfo3a = textConst.textData.other.kontaktInfo3a.en;
            state.kontaktInfo3b = textConst.textData.other.kontaktInfo3b.en;
            state.kontaktInfo3c = textConst.textData.other.kontaktInfo3c.en;

            state.kontaktInfo4a = textConst.textData.other.kontaktInfo4a.en;
            state.kontaktInfo4b = textConst.textData.other.kontaktInfo4b.en;
            state.kontaktInfo4c = textConst.textData.other.kontaktInfo4c.en;

            state.mainInfoTitle = textConst.textData.other.mainInfoTitle.en;
            state.mainInfoSubTitle = textConst.textData.other.mainInfoSubTitle.en;
            state.mainInfo1 = textConst.textData.other.mainInfo1.en;
            state.mainInfo2 = textConst.textData.other.mainInfo2.en;
            state.mainInfo3 = textConst.textData.other.mainInfo3.en;
            state.mainInfo4 = textConst.textData.other.mainInfo4.en;
            state.mainInfo5 = textConst.textData.other.mainInfo5.en;
            state.mainInfo6 = textConst.textData.other.mainInfo6.en;
            state.mainInfo7 = textConst.textData.other.mainInfo7.en;

            state.menuAll = textConst.textData.other.menuAll.en;
            
            state.newsNavTitle = textConst.textData.en.news.nav;
            state.newsText = textConst.textData.en.news.text;

            state.newsArray = newsData.data.en;
            state.latestNews = latestData.data.en;
            state.close = textConst.textData.other.close.en;
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}